module.exports = __webpack_public_path__ + "static/media/Galdisa_Ficha_Cacahuate_enchilado.8ad25228.pdf";